import { getConfigDefaults } from "../api/configLoader.js";
export function isQuoteEmbedPathname() {
  try {
    const p = (window.location.pathname || "").replace(/\/$/, "").toLowerCase();
    return p === "/embed/quote";
  } catch {
    return false;
  }
}
export async function loadQuoteEmbedBootstrap(publicId) {
  const base = getConfigDefaults();
  const apiUrl = `${window.location.origin.replace(/\/$/, "")}/api`;
  const res = await fetch(`${apiUrl}/nitromule/v1/embed/quote-bootstrap?k=${encodeURIComponent(publicId)}`, {
    credentials: "omit"
  });
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try {
      const j = await res.json();
      if (j?.message) msg = j.message;
    } catch {}
    throw new Error(msg);
  }
  const data = await res.json();
  window.nitromuleReactData = {
    ...base,
    ...data,
    apiUrl
  };
  window.__NM_QUOTE_EMBED_PUBLIC_ID__ = publicId;
  return window.nitromuleReactData;
}
